import { render, staticRenderFns } from "./DialogDelete.vue?vue&type=template&id=4300d08c&scoped=true"
import script from "./DialogDelete.js?vue&type=script&lang=js&external"
export * from "./DialogDelete.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300d08c",
  null
  
)

export default component.exports